customElements.component = 'reviews-slider';

if (!customElements.get(customElements.component)) {
  class ReviewsSlider extends HTMLElement {
    constructor() {
      super();

      this.sliderElement = this.querySelector('.js-reviews-slider');
      this.autoplay = this.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(this.dataset.autoplaySpeed);
      this.showArrows = this.dataset.showArrows === 'true';
      this.loop = this.dataset.loop === 'true';
      this.draggable = this.dataset.draggable === 'true';

      this.arrowPrev = this.querySelector('.js-slide-prev');
      this.arrowNext = this.querySelector('.js-slide-next');
    }

    initializeSlider() {
      if(!this.showArrows){
        this.draggable = true;
      }

      const params = {
        slidesPerView: 1,
        loopAdditionalSlides: 3,
        spaceBetween: 20,
        initialSlide: 2,
        centeredSlides: true,
        loop: this.loop,
        allowTouchMove: this.draggable,
        breakpoints: {
          768: {
            slidesPerView: 3
          }
        }
      }

      if (this.showArrows) {
        params.navigation = {
          nextEl: this.arrowNext,
          prevEl: this.arrowPrev, 
        }
      }

      if (this.autoplay) {
        params.autoplay = {
          delay: this.autoplaySpeed,
          disableOnInteraction: false
        }
      }

      this.slider = new Swiper(this.sliderElement, params);
    }

    connectedCallback() {
      this.initializeSlider();
    }

    disconnectedCallback() {
      this.slider?.destroy(true, true);
    }
  }

  customElements.define(customElements.component, ReviewsSlider);
}